import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import BreadCrump from '../tools/breadcrump';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import ImageUploaders from '../tools/uploaderimages';
import { Button, Input, Tabs, TagInput, SelectPicker } from 'rsuite';
import QACreator from '../Qa/QaComponent';
import PriceEditor from './PriceEditor';
import HeaderOfPage from '../tools/headerOfPage';
import changeUrl from "../../hoc/changeur";
import GiftProductSelector from './GiftProductSelector';

interface ProductColor {
    name: string;
    hex: string;
    stock: boolean;
}

interface ProductSize {
    name: string;
    stock: boolean;
}

export default function EditProducts() {
    const { t } = useTranslation();

    let cookie = getCookies();
    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [list, setListArticle] = useState<any>(null);
    const [brands, setBrands] = useState<any>(null);
    const [pricellist, setPriceList] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [feature, setFeature] = useState<any>([]);
    const [groupFeatures, setGroupFeatures] = useState<any[]>([]);
    const [productFeatureData, setProductFeatureData] = useState<any[]>([]);
    const [productFeatureValues, setProductFeatureValues] = useState<Record<string, Record<string, string>>>({});
    const [keyprice, setKeyprice] = useState<any>(1);
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [activeLang, setActiveLang] = useState<string>('en');
    const [giftProducts, setGiftProducts] = useState<string[]>([]);
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    // Default colors for clothes products
    const defaultColors: ProductColor[] = [
        { name: 'Black', hex: '#000000', stock: false },
        { name: 'White', hex: '#FFFFFF', stock: false },
        { name: 'Red', hex: '#FF0000', stock: false },
        { name: 'Blue', hex: '#0000FF', stock: false },
        { name: 'Green', hex: '#008000', stock: false },
        { name: 'Yellow', hex: '#FFFF00', stock: false },
        { name: 'Orange', hex: '#FFA500', stock: false },
        { name: 'Purple', hex: '#800080', stock: false },
        { name: 'Pink', hex: '#FFC0CB', stock: false },
        { name: 'Gray', hex: '#808080', stock: false },
        { name: 'Brown', hex: '#A52A2A', stock: false },
        { name: 'Navy', hex: '#000080', stock: false },
    ];

    // Default sizes for products
    const defaultSizes: string[] = [
        'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL',
        '28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50',
        'One Size', 'Free Size'
    ];

    // Helper function to get display name from multilingual or string
    const getDisplayName = (name: any, lang?: string): string => {
        const activeLanguage = lang || activeLang;
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name[activeLanguage] || name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    // Helper function to render group options with unlimited levels
    const renderGroupOptions = (groups: any[], level: number = 0, isLast: boolean[] = []): JSX.Element[] => {
        if (!groups || !Array.isArray(groups)) return [];
        
        return groups.map((group: any, index: number) => {
            const displayName = getDisplayName(group.name);
            const groupId = group._id || group.id;
            const isLastItem = index === groups.length - 1;
            const currentIsLast = [...isLast, isLastItem];
            
            // Visual indicator for hierarchy levels
            let prefix = '';
            if (level > 0) {
                // Build prefix based on parent levels
                const prefixParts: string[] = [];
                for (let i = 0; i < level - 1; i++) {
                    prefixParts.push(currentIsLast[i] ? '   ' : '│  ');
                }
                prefixParts.push(isLastItem ? '└─ ' : '├─ ');
                prefix = prefixParts.join('');
            }
            
            const children = group.togroup && Array.isArray(group.togroup) && group.togroup.length > 0
                ? renderGroupOptions(group.togroup, level + 1, currentIsLast)
                : [];
            
            return (
                <React.Fragment key={groupId}>
                    <option value={groupId}>
                        {prefix}{displayName}
                    </option>
                    {children}
                </React.Fragment>
            );
        });
    };

    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/pproducts/${Id}`;
            // Include gift products in the data
            const dataToSave = {
                ...data,
                giftProducts: giftProducts
            };
            let res = await axios({
                method: 'put',
                data: dataToSave,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Product updated successfully'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            // Safely extract error message - handle both string and object errors
            let errorMessage = t('Error updating product');
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    // Handle Mongoose validation errors or other error objects
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSaving(false);
        }
    }

    // Load languages
    const loadLanguages = async (): Promise<Array<{ code: string; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data.message || [];
            const mappedLanguages = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0))
                .map((lang: any) => ({
                    code: lang.code,
                    label: lang.label
                }));
            setLanguages(mappedLanguages);
            if (mappedLanguages.length > 0) {
                setActiveLang(mappedLanguages[0].code);
            }
            return mappedLanguages;
        } catch (error) {
            console.error('Error loading languages:', error);
            const fallbackLanguages = [
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ];
            setLanguages(fallbackLanguages);
            return fallbackLanguages;
        }
    };

    // Helper function to initialize multilingual field
    const initializeMultilingualField = (field: any, languageCodes: string[]): any => {
        if (!field) {
            const obj: any = {};
            languageCodes.forEach(code => obj[code] = '');
            return obj;
        }
        if (typeof field === 'string') {
            const obj: any = {};
            languageCodes.forEach(code => obj[code] = field);
            return obj;
        }
        if (typeof field === 'object') {
            if (field.nl) {
                field.ku = field.nl;
                delete field.nl;
            }
            const obj: any = { ...field };
            languageCodes.forEach(code => {
                if (!obj[code]) obj[code] = '';
            });
            return obj;
        }
        const obj: any = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    };

    const load = async (languageCodes: string[] = []) => {
        setLoading(true);
        try {
            var path = `${config.url}/v1/dashboard/pproducts/${Id}`;
            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Check if product data exists
            if (!loadedData) {
                throw new Error(t('Product not found'));
            }
            const codes = languageCodes.length > 0 
                ? languageCodes
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            
            // Ensure multilingual structure exists
            if (loadedData) {
                loadedData.name = initializeMultilingualField(loadedData.name, codes);
                loadedData.title = initializeMultilingualField(loadedData.title, codes);
                loadedData.description = initializeMultilingualField(loadedData.description, codes);
                loadedData.keywords = initializeMultilingualField(loadedData.keywords, codes);
                loadedData.alt = initializeMultilingualField(loadedData.alt, codes);
                loadedData.specials = initializeMultilingualField(loadedData.specials, codes);
                loadedData.url = initializeMultilingualField(loadedData.url, codes);
            }
            // Ensure colors array exists and normalize color objects
            if (!loadedData.colors || !Array.isArray(loadedData.colors)) {
                loadedData.colors = [];
            } else {
                // Normalize colors - ensure they have the correct structure
                loadedData.colors = loadedData.colors.map((color: any) => ({
                    name: color.name || '',
                    hex: (color.hex || '').toUpperCase().trim(), // Normalize hex to uppercase and trim
                    stock: color.stock !== undefined ? color.stock : false
                })).filter((color: any) => color.name && color.hex); // Remove invalid colors
            }
            // Ensure sizes array exists and normalize size objects
            if (!loadedData.sizes || !Array.isArray(loadedData.sizes)) {
                loadedData.sizes = [];
            } else {
                // Normalize sizes - ensure they have the correct structure
                loadedData.sizes = loadedData.sizes.map((size: any) => ({
                    name: typeof size === 'string' ? size : (size.name || ''),
                    stock: typeof size === 'object' && size.stock !== undefined ? size.stock : false
                })).filter((size: any) => size.name); // Remove invalid sizes
            }
            // Ensure availability has a default value
            if (loadedData.available === undefined || loadedData.available === null) {
                loadedData.available = true;
            }
            // Ensure type has a default value
            if (!loadedData.type) {
                loadedData.type = 'retail';
            }
            // Initialize gift products array and normalize IDs to strings
            if (!loadedData.giftProducts || !Array.isArray(loadedData.giftProducts)) {
                loadedData.giftProducts = [];
            } else {
                // Normalize gift product IDs to strings for consistent comparison
                loadedData.giftProducts = loadedData.giftProducts.map((id: any) => String(id || '').trim()).filter((id: string) => id !== '');
            }
            // Initialize marketplacePrices array
            if (!loadedData.marketplacePrices || !Array.isArray(loadedData.marketplacePrices)) {
                loadedData.marketplacePrices = [];
            }
            setData(loadedData);
            setGiftProducts(loadedData.giftProducts || []);
            setFeature(res.data.feature);
            // Load product feature data for this product
            await loadProductDataFeatures(loadedData._id || Id);
        } catch (error: any) {
            // Safely extract error message
            let errorMessage = t('Error loading product');
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setLoading(false);
        }
    }

    const getalldata = async () => {
        try {
            // Get all groups without filtering
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup/getall',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            const allGroups = res.data.message || [];
            
            // Build tree structure from flat list
            const buildTree = (groups: any[], parentId: string | null = null): any[] => {
                return groups
                    .filter((group: any) => {
                        const groupParent = group.subgroup || null;
                        return (parentId === null && (groupParent === null || groupParent === '')) ||
                               (parentId !== null && groupParent === parentId);
                    })
                    .map((group: any) => {
                        const children = buildTree(groups, group._id || group.id);
                        return {
                            ...group,
                            togroup: children.length > 0 ? children : undefined
                        };
                    })
                    .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0));
            };

            const treeGroups = buildTree(allGroups);
            setListArticle(treeGroups);
        } catch (error) {
            console.error('Error loading groups:', error);
        }

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/productprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setPriceList(res.data.message);
        } catch (error) {
            console.error('Error loading price lists:', error);
        }

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/brands',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setBrands(res.data.message);
        } catch (error) {
            console.error('Error loading brands:', error);
        }
    }

    const loadGroupFeatures = async (groupId: string) => {
        if (!groupId) {
            setGroupFeatures([]);
            return;
        }
        try {
            let res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/productsfeature?productGroupId=${groupId}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            // Normalize feature names to multilingual structure
            const languageCodes = languages.length > 0 
                ? languages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            
            const normalizedFeatures = (res.data.message || []).map((feature: any) => {
                feature.name = initializeMultilingualField(feature.name, languageCodes);
                
                // Normalize options to multilingual structure with IDs
                if (feature.options && Array.isArray(feature.options)) {
                    console.log(`Feature ${feature.name?.fa || feature.name?.en || 'Unknown'}: Original options:`, feature.options);
                    feature.options = feature.options.map((opt: any, idx: number) => {
                        if (typeof opt === 'string') {
                            // Legacy: convert string to object with id and multilingual name
                            const optName: any = {};
                            languageCodes.forEach(code => optName[code] = opt);
                            return {
                                id: `opt_${feature._id}_${idx}_${Date.now()}`,
                                name: optName
                            };
                        } else if (opt && typeof opt === 'object') {
                            // Ensure id exists
                            if (!opt.id) {
                                opt.id = `opt_${feature._id}_${idx}_${Date.now()}`;
                            }
                            // Ensure multilingual name structure
                            opt.name = initializeMultilingualField(opt.name, languageCodes);
                            return opt;
                        }
                        return opt;
                    });
                    console.log(`Feature ${feature.name?.fa || feature.name?.en || 'Unknown'}: Normalized options:`, feature.options);
                }
                
                return feature;
            });
            console.log('All normalized features:', normalizedFeatures);
            setGroupFeatures(normalizedFeatures);
        } catch (error) {
            console.error('Error loading group features:', error);
        }
    }

    const loadProductDataFeatures = async (productId: string) => {
        try {
            let res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/productDataFeature?product=${productId}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const items = res.data.message || [];
            setProductFeatureData(items);
            const languageCodes = languages.length > 0 
                ? languages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            const values: Record<string, any> = {};
            items.forEach((item: any) => {
                if (item.feature) {
                    // Normalize value to multilingual structure
                    values[item.feature] = initializeMultilingualField(item.value, languageCodes);
                }
            });
            setProductFeatureValues(values);
        } catch (error) {
            console.error('Error loading product data features:', error);
        }
    }

    const handleChangeFeatureValue = (featureId: string, value: string) => {
        setProductFeatureValues(prev => {
            const languageCodes = languages.length > 0 
                ? languages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            const emptyValue: any = {};
            languageCodes.forEach(code => emptyValue[code] = '');
            const currentValue = prev[featureId] || emptyValue;
            return {
                ...prev,
                [featureId]: {
                    ...currentValue,
                    [activeLang]: value
                }
            };
        });
    };

    // Helper to get multilingual value
    const getMultilingualValue = (value: any, lang: string = activeLang): string => {
        if (!value) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            return value[lang] || value.en || value.fa || value.ku || value.ar || value.tr || '';
        }
        return String(value);
    };

    const saveProductFeatures = async () => {
        if (!data || !data._id) return;
        try {
            const baseUrl = `${config.url}/v1/dashboard/productDataFeature`;
            const requests: Promise<any>[] = [];

            const languageCodes = languages.length > 0 
                ? languages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            const emptyValue: any = {};
            languageCodes.forEach(code => emptyValue[code] = '');
            
            groupFeatures.forEach((f: any) => {
                const featureId = f._id;
                const currentValue = productFeatureValues[featureId] || emptyValue;
                const existing = productFeatureData.find((x: any) => x.feature === featureId);

                // Check if at least one language has a value
                const hasValue = languageCodes.some(code => currentValue[code]);

                // Delete if exists and all values are empty
                if (existing && !hasValue) {
                    requests.push(axios({
                        method: 'delete',
                        url: `${baseUrl}/${existing._id}`,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    }));
                }
                // Update if exists and value changed
                else if (existing) {
                    // Compare multilingual values
                    const existingValue = existing.value || {};
                    const existingNormalized = initializeMultilingualField(existingValue, languageCodes);
                    
                    const valuesEqual = JSON.stringify(currentValue) === JSON.stringify(existingNormalized);
                    if (!valuesEqual) {
                        requests.push(axios({
                            method: 'put',
                            url: `${baseUrl}/${existing._id}`,
                            data: { value: currentValue },
                            headers: {
                                Authorization: 'Bearer ' + cookie['token'],
                            }
                        }));
                    }
                }
                // Create if not exists and has value
                else if (!existing && hasValue) {
                    requests.push(axios({
                        method: 'post',
                        url: baseUrl,
                        data: {
                            product: data._id,
                            feature: featureId,
                            value: currentValue,
                        },
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    }));
                }
            });

            if (requests.length > 0) {
                await Promise.all(requests);
                await loadProductDataFeatures(data._id);
            }

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: 'ویژگی‌های محصول ذخیره شد',
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            // Safely extract error message
            let errorMessage = 'خطا در ذخیره ویژگی‌ها';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        }
    };

    const CreatePriceGroup = async () => {
        try {
            let res = await axios({
                method: 'post',
                data: {
                    name: data.id,
                    model: 'selfprice',
                    url: data.id
                },
                url: config.url + '/v1/dashboard/productprice/selfprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData({ ...data, price: res.data.message });
            setKeyprice(keyprice + 1);
            
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Exclusive pricing created'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            // Safely extract error message
            let errorMessage = t('Error creating pricing');
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        }
    }

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'List Products',
            url: '/dashboard/Products/Products'
        },
        {
            name: 'Edit Product',
            url: null
        },
    ]

    useEffect(() => {
        const initialize = async () => {
            const loadedLanguages = await loadLanguages();
            const languageCodes = loadedLanguages.length > 0
                ? loadedLanguages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            await Promise.all([getalldata(), load(languageCodes)]);
        };
        initialize();
    }, []);

    // Update data when languages change
    useEffect(() => {
        if (languages.length > 0 && data) {
            const languageCodes = languages.map(l => l.code);
            const updatedData = { ...data };
            updatedData.name = initializeMultilingualField(data.name, languageCodes);
            updatedData.title = initializeMultilingualField(data.title, languageCodes);
            updatedData.description = initializeMultilingualField(data.description, languageCodes);
            updatedData.keywords = initializeMultilingualField(data.keywords, languageCodes);
            updatedData.alt = initializeMultilingualField(data.alt, languageCodes);
            updatedData.specials = initializeMultilingualField(data.specials, languageCodes);
            updatedData.url = initializeMultilingualField(data.url, languageCodes);
            setData(updatedData);
        }
    }, [languages]);

    useEffect(() => {
        if (data && data.parent) {
            loadGroupFeatures(data.parent);
        }
    }, [data?.parent]);

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    if (loading) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Edit Product"></HeaderOfPage>
                <div className="bg-white rounded-xl shadow-sm p-8 mt-6">
                    <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                    <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="Edit Product"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                        <Tabs defaultActiveKey="1" appearance="pills">
                            <Tabs.Tab eventKey="1" title="اطلاعات عمومی">
                                <div className="p-6 space-y-6" dir="rtl">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                        {/* Thumbnail Upload */}
                                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-800 mb-1">
                                                    تصویر اصلی محصول
                                                </h3>
                                                <p className="text-xs text-gray-500">
                                                    یک تصویر واضح با کیفیت مناسب برای نمایش در لیست و صفحه محصول انتخاب کنید.
                                                </p>
                                            </div>
                                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                                                <ImageUploader id={data._id} component={'Product'}></ImageUploader>
                                            </div>
                                        </div>

                                        {/* Basic Information Form */}
                                        <div className="lg:col-span-2 space-y-6">
                                            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-4">
                                                <div className="flex items-center justify-between mb-2">
                                                    <h3 className="text-sm font-semibold text-gray-800">اطلاعات پایه</h3>
                                                    <span className="text-xs text-gray-400">الزامی</span>
                                                </div>
                                                <form key={key} className="space-y-4">
                                                    {/* Language Selector */}
                                                    <div className="mb-4">
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            زبان / Language
                                                        </label>
                                                        <div className="flex gap-2 flex-wrap">
                                                            {languages.map((lang) => (
                                                                <button
                                                                    key={lang.code}
                                                                    type="button"
                                                                    onClick={() => setActiveLang(lang.code)}
                                                                    className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                                                        activeLang === lang.code
                                                                            ? 'bg-blue-600 text-white'
                                                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                                    }`}
                                                                >
                                                                    {lang.label}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                value={data.name?.[activeLang] || ''}
                                                                type="text"
                                                                className={inputstyle}
                                                                placeholder="نام محصول را وارد کنید"
                                                                onChange={(e) => {
                                                                    const nameValue = e.target.value;
                                                                    const slugValue = String(changeUrl(nameValue));
                                                                    setData({ 
                                                                        ...data, 
                                                                        name: { 
                                                                            ...data.name, 
                                                                            [activeLang]: nameValue 
                                                                        },
                                                                        url: {
                                                                            ...data.url,
                                                                            [activeLang]: slugValue
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                URL ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={data.url?.[activeLang] || ''}
                                                                className={inputstyle}
                                                                placeholder="مثال: product-name"
                                                                onChange={(e) => {
                                                                    const urlValue = e.target.value;
                                                                    setData({ 
                                                                        ...data, 
                                                                        url: { 
                                                                            ...data.url, 
                                                                            [activeLang]: urlValue 
                                                                        } 
                                                                    });
                                                                }}
                                                            />
                                                            <p className="mt-1 text-xs text-gray-400">
                                                                آدرس یکتای محصول در سایت (به انگلیسی و بدون فاصله).
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            {t('Group')}
                                                        </label>
                                                        <select
                                                            value={data.parent || ''}
                                                            onChange={(e) => setData({ ...data, parent: e.target.value })}
                                                            className={inputstyle}
                                                        >
                                                            <option value="">انتخاب گروه...</option>
                                                            {list != null && Array.isArray(list) && list.length > 0 && renderGroupOptions(list)}
                                                        </select>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                قیمت پایه (تومان)
                                                            </label>
                                                            <input
                                                                value={data.mainprice || ''}
                                                                type="number"
                                                                dir="ltr"
                                                                className={inputstyle}
                                                                placeholder="مثال: 250000"
                                                                onChange={(e) => setData({ ...data, mainprice: e.target.value })}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                Alt Text ({languages.find(l => l.code === activeLang)?.label})
                                                            </label>
                                                            <Input
                                                                dir='ltr'
                                                                value={data.alt?.[activeLang] || ''}
                                                                className={inputstyle}
                                                                onChange={(e) => setData({ 
                                                                    ...data, 
                                                                    alt: { 
                                                                        ...data.alt, 
                                                                        [activeLang]: e 
                                                                    } 
                                                                })}
                                                                placeholder="مثال: PRD-1001"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                SKU
                                                            </label>
                                                            <input
                                                                value={data.sku || ''}
                                                                type="text"
                                                                dir="ltr"
                                                                className={inputstyle + " text-left"}
                                                                placeholder="SKU"
                                                                onChange={(e) => setData({ ...data, sku: e.target.value })}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                کد محصول / Product Code
                                                            </label>
                                                            <input
                                                                value={data.productCode || ''}
                                                                type="text"
                                                                dir="ltr"
                                                                className={inputstyle + " text-left"}
                                                                placeholder="Product Code"
                                                                onChange={(e) => setData({ ...data, productCode: e.target.value })}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                موجودی / Stock
                                                            </label>
                                                            <input
                                                                value={data.stock || 0}
                                                                type="number"
                                                                dir="ltr"
                                                                className={inputstyle}
                                                                placeholder="0"
                                                                min="0"
                                                                onChange={(e) => setData({ ...data, stock: e.target.value ? parseInt(e.target.value) : 0 })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                نوع / Type
                                                            </label>
                                                            <select
                                                                value={data.type || 'retail'}
                                                                onChange={(e) => setData({ ...data, type: e.target.value })}
                                                                className={inputstyle}
                                                            >
                                                                <option value="retail">خرده فروشی / Retail</option>
                                                                <option value="wholesale">عمده فروشی / Wholesale</option>
                                                            </select>
                                                        </div>

                                                        <div className="flex items-center gap-3">
                                                            <label className="flex items-center gap-2 cursor-pointer">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={data.available !== undefined ? data.available : true}
                                                                    onChange={(e) => setData({ ...data, available: e.target.checked })}
                                                                    className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                                />
                                                                <span className="text-sm font-medium text-gray-700">
                                                                    موجود / Available
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                {t('Brand')}
                                                            </label>
                                                            <select
                                                                value={data.brand || ''}
                                                                onChange={(e) => setData({ ...data, brand: e.target.value })}
                                                                className={inputstyle}
                                                            >
                                                                <option value="">انتخاب برند...</option>
                                                                {
                                                                    brands != null && Array.isArray(brands) && brands.length > 0 && brands.map((item: any) => {
                                                                        return (
                                                                            <option key={item.id} value={item.id}>{getDisplayName(item.name)}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>

                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                {t('مدل پخش')}
                                                            </label>
                                                            <select
                                                                value={data.listmode || 0}
                                                                onChange={(e) => setData({ ...data, listmode: e.target.value })}
                                                                className={inputstyle}
                                                            >
                                                                <option value={0}>{t('نوع یک')}</option>
                                                                <option value={1}>{t('نوع دو')}</option>
                                                                <option value={2}>{t('نوع سه')}</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Color Selection */}
                                                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-3">
                                                        <div className="flex items-center justify-between">
                                                            <h3 className="text-sm font-semibold text-gray-800">رنگ‌های محصول / Product Colors</h3>
                                                            {data && data.colors && Array.isArray(data.colors) && (
                                                                <span className="text-xs text-gray-500">({data.colors.length} رنگ انتخاب شده)</span>
                                                            )}
                                                        </div>
                                                        <div className="space-y-3">
                                                            {/* Default Colors Palette */}
                                                            <div>
                                                                <p className="text-xs text-gray-500 mb-2">رنگ‌های پیش‌فرض:</p>
                                                                <div className="flex flex-wrap gap-2">
                                                                    {defaultColors.map((color) => {
                                                                        // Normalize hex comparison (case-insensitive, trimmed)
                                                                        const normalizedColorHex = color.hex.toUpperCase().trim();
                                                                        const isSelected = data?.colors?.some((c: ProductColor) => {
                                                                            const normalizedCHex = (c.hex || '').toUpperCase().trim();
                                                                            return normalizedCHex === normalizedColorHex;
                                                                        });
                                                                        return (
                                                                            <button
                                                                                key={color.hex}
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    const currentColors = data.colors || [];
                                                                                    if (isSelected) {
                                                                                        // Remove color if already selected (normalize comparison)
                                                                                        const normalizedColorHex = color.hex.toUpperCase().trim();
                                                                                        setData({ 
                                                                                            ...data, 
                                                                                            colors: currentColors.filter((c: ProductColor) => {
                                                                                                const normalizedCHex = (c.hex || '').toUpperCase().trim();
                                                                                                return normalizedCHex !== normalizedColorHex;
                                                                                            })
                                                                                        });
                                                                                    } else {
                                                                                        // Add color with default stock: false
                                                                                        setData({ 
                                                                                            ...data, 
                                                                                            colors: [...currentColors, { ...color, stock: false }]
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                className={`relative w-10 h-10 rounded-lg border-2 transition-all ${
                                                                                    isSelected 
                                                                                        ? 'border-blue-600 ring-2 ring-blue-300' 
                                                                                        : 'border-gray-300 hover:border-gray-400'
                                                                                }`}
                                                                                style={{ backgroundColor: color.hex }}
                                                                                title={color.name}
                                                                            >
                                                                                {isSelected && (
                                                                                    <div className="absolute inset-0 flex items-center justify-center">
                                                                                        <svg className="w-5 h-5 text-white drop-shadow-lg" fill="currentColor" viewBox="0 0 20 20">
                                                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                                        </svg>
                                                                                    </div>
                                                                                )}
                                                                            </button>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>

                                                            {/* Selected Colors with Stock Toggle */}
                                                            {data && data.colors && Array.isArray(data.colors) && data.colors.length > 0 ? (
                                                                <div className="mt-4 space-y-2">
                                                                    <p className="text-xs text-gray-500 mb-2">رنگ‌های انتخاب شده ({data.colors.length}):</p>
                                                                    <div className="space-y-2 max-h-48 overflow-y-auto">
                                                                        {data.colors.map((color: ProductColor, index: number) => {
                                                                            // Ensure color has required properties
                                                                            const normalizedColor: ProductColor = {
                                                                                name: color.name || 'Unknown',
                                                                                hex: (color.hex || '#000000').toUpperCase().trim(),
                                                                                stock: color.stock !== undefined ? color.stock : false
                                                                            };
                                                                            return (
                                                                            <div key={index} className="flex items-center gap-3 p-2 bg-white rounded-lg border border-gray-200">
                                                                                <div
                                                                                    className="w-8 h-8 rounded border border-gray-300 flex-shrink-0"
                                                                                    style={{ backgroundColor: normalizedColor.hex }}
                                                                                    title={normalizedColor.name}
                                                                                />
                                                                                <div className="flex-1 min-w-0">
                                                                                    <p className="text-sm font-medium text-gray-700 truncate">{normalizedColor.name}</p>
                                                                                    <p className="text-xs text-gray-500">{normalizedColor.hex}</p>
                                                                                </div>
                                                                                <label className="flex items-center gap-2 cursor-pointer">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={normalizedColor.stock}
                                                                                        onChange={(e) => {
                                                                                            const updatedColors = [...(data.colors || [])];
                                                                                            updatedColors[index] = { ...normalizedColor, stock: e.target.checked };
                                                                                            setData({ 
                                                                                                ...data, 
                                                                                                colors: updatedColors
                                                                                            });
                                                                                        }}
                                                                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                                                    />
                                                                                    <span className="text-sm text-gray-700">موجود</span>
                                                                                </label>
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                        const updatedColors = (data.colors || []).filter((_: ProductColor, i: number) => i !== index);
                                                                                        setData({ 
                                                                                            ...data, 
                                                                                            colors: updatedColors
                                                                                        });
                                                                                    }}
                                                                                    className="text-red-600 hover:text-red-800 p-1"
                                                                                    title="حذف رنگ"
                                                                                >
                                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="mt-4 p-3 bg-gray-100 rounded-lg">
                                                                    <p className="text-xs text-gray-500">هیچ رنگی انتخاب نشده است</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Size Selection */}
                                                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-3">
                                                        <div className="flex items-center justify-between">
                                                            <h3 className="text-sm font-semibold text-gray-800">سایزهای محصول / Product Sizes</h3>
                                                            {data && data.sizes && Array.isArray(data.sizes) && (
                                                                <span className="text-xs text-gray-500">({data.sizes.length} سایز انتخاب شده)</span>
                                                            )}
                                                        </div>
                                                        <div className="space-y-3">
                                                            {/* Default Sizes Palette */}
                                                            <div>
                                                                <p className="text-xs text-gray-500 mb-2">سایزهای پیش‌فرض:</p>
                                                                <div className="flex flex-wrap gap-2">
                                                                    {defaultSizes.map((sizeName) => {
                                                                        const isSelected = data?.sizes?.some((s: ProductSize) => {
                                                                            const sizeNameToCompare = typeof s === 'string' ? s : s.name;
                                                                            return sizeNameToCompare === sizeName;
                                                                        });
                                                                        return (
                                                                            <button
                                                                                key={sizeName}
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    const currentSizes = data.sizes || [];
                                                                                    if (isSelected) {
                                                                                        // Remove size if already selected
                                                                                        setData({ 
                                                                                            ...data, 
                                                                                            sizes: currentSizes.filter((s: ProductSize) => {
                                                                                                const sizeNameToCompare = typeof s === 'string' ? s : s.name;
                                                                                                return sizeNameToCompare !== sizeName;
                                                                                            })
                                                                                        });
                                                                                    } else {
                                                                                        // Add size with default stock: false
                                                                                        setData({ 
                                                                                            ...data, 
                                                                                            sizes: [...currentSizes, { name: sizeName, stock: false }]
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                className={`px-4 py-2 text-sm font-medium rounded-lg border-2 transition-all ${
                                                                                    isSelected 
                                                                                        ? 'border-blue-600 bg-blue-50 text-blue-700 ring-2 ring-blue-300' 
                                                                                        : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:bg-gray-50'
                                                                                }`}
                                                                            >
                                                                                {sizeName}
                                                                                {isSelected && (
                                                                                    <span className="ml-1">✓</span>
                                                                                )}
                                                                            </button>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>

                                                            {/* Custom Size Input */}
                                                            <div>
                                                                <p className="text-xs text-gray-500 mb-2">افزودن سایز سفارشی:</p>
                                                                <div className="flex gap-2">
                                                                    <input
                                                                        type="text"
                                                                        id="customSizeInput"
                                                                        className={`${inputstyle} flex-1`}
                                                                        placeholder="مثال: 2XL, 52, ..."
                                                                        onKeyPress={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                const input = e.target as HTMLInputElement;
                                                                                const customSize = input.value.trim();
                                                                                if (customSize && !data?.sizes?.some((s: ProductSize) => {
                                                                                    const sizeNameToCompare = typeof s === 'string' ? s : s.name;
                                                                                    return sizeNameToCompare === customSize;
                                                                                })) {
                                                                                    setData({ 
                                                                                        ...data, 
                                                                                        sizes: [...(data.sizes || []), { name: customSize, stock: false }]
                                                                                    });
                                                                                    input.value = '';
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Selected Sizes with Stock Toggle */}
                                                            {data && data.sizes && Array.isArray(data.sizes) && data.sizes.length > 0 ? (
                                                                <div className="mt-4 space-y-2">
                                                                    <p className="text-xs text-gray-500 mb-2">سایزهای انتخاب شده ({data.sizes.length}):</p>
                                                                    <div className="space-y-2 max-h-48 overflow-y-auto">
                                                                        {data.sizes.map((size: ProductSize, index: number) => {
                                                                            // Ensure size has required properties
                                                                            const normalizedSize: ProductSize = {
                                                                                name: typeof size === 'string' ? size : (size.name || 'Unknown'),
                                                                                stock: typeof size === 'object' && size.stock !== undefined ? size.stock : false
                                                                            };
                                                                            return (
                                                                            <div key={index} className="flex items-center gap-3 p-2 bg-white rounded-lg border border-gray-200">
                                                                                <div className="flex-1 min-w-0">
                                                                                    <p className="text-sm font-medium text-gray-700">{normalizedSize.name}</p>
                                                                                </div>
                                                                                <label className="flex items-center gap-2 cursor-pointer">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={normalizedSize.stock}
                                                                                        onChange={(e) => {
                                                                                            const updatedSizes = [...(data.sizes || [])];
                                                                                            updatedSizes[index] = { ...normalizedSize, stock: e.target.checked };
                                                                                            setData({ 
                                                                                                ...data, 
                                                                                                sizes: updatedSizes
                                                                                            });
                                                                                        }}
                                                                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                                                    />
                                                                                    <span className="text-sm text-gray-700">موجود</span>
                                                                                </label>
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                        const updatedSizes = (data.sizes || []).filter((_: ProductSize, i: number) => i !== index);
                                                                                        setData({ 
                                                                                            ...data, 
                                                                                            sizes: updatedSizes
                                                                                        });
                                                                                    }}
                                                                                    className="text-red-600 hover:text-red-800 p-1"
                                                                                    title="حذف سایز"
                                                                                >
                                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="mt-4 p-3 bg-gray-100 rounded-lg">
                                                                    <p className="text-xs text-gray-500">هیچ سایزی انتخاب نشده است</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>

                                            {/* Feature Toggles */}
                                            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-4">
                                                <div className="flex items-center justify-between">
                                                    <h3 className="text-sm font-semibold text-gray-800">نمایش در سایت</h3>
                                                    <span className="text-xs text-gray-400">کنترل بخش‌های خاص در صفحه اول</span>
                                                </div>

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            {t('جدیدترین ها')}
                                                        </label>
                                                        <select
                                                            value={data.special || 0}
                                                            onChange={(e) => setData({ ...data, special: e.target.value })}
                                                            className={inputstyle}
                                                        >
                                                            <option value={0}>{t('خیر')}</option>
                                                            <option value={1}>{t('بله')}</option>
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            {t('پرفروش ها')}
                                                        </label>
                                                        <select
                                                            value={data.firstpage || 0}
                                                            onChange={(e) => setData({ ...data, firstpage: e.target.value })}
                                                            className={inputstyle}
                                                        >
                                                            <option value={0}>{t('خیر')}</option>
                                                            <option value={1}>{t('بله')}</option>
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            {t('ویژه صفحه اول')}
                                                        </label>
                                                        <select
                                                            value={data.special1 || 0}
                                                            onChange={(e) => setData({ ...data, special1: e.target.value })}
                                                            className={inputstyle}
                                                        >
                                                            <option value={0}>{t('خیر')}</option>
                                                            <option value={1}>{t('بله')}</option>
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            {t('دسته بندی محصولات')}
                                                        </label>
                                                        <select
                                                            value={data.special2 || 0}
                                                            onChange={(e) => setData({ ...data, special2: e.target.value })}
                                                            className={inputstyle}
                                                        >
                                                            <option value={0}>{t('خیر')}</option>
                                                            <option value={1}>{t('بله')}</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                        {t('محل صفحه اول')}
                                                    </label>
                                                    <select
                                                        value={data.specialsection || ''}
                                                        onChange={(e) => setData({ ...data, specialsection: e.target.value })}
                                                        className={inputstyle}
                                                    >
                                                        <option value="">انتخاب کنید...</option>
                                                        {
                                                            list != null && Array.isArray(list) && list.length > 0 && list.map((item: any) => {
                                                                return (
                                                                    <option key={item.id} value={item.id}>
                                                                        {getDisplayName(item.name)}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                    <p className="mt-1 text-xs text-gray-400">
                                                        تعیین محل نمایش محصول در بلوک‌های مختلف صفحه اول.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="flex justify-end pt-2">
                                                <button
                                                    type="button"
                                                    onClick={save}
                                                    disabled={saving}
                                                    className="inline-flex items-center justify-center gap-x-2 px-6 py-2.5 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                                                >
                                                    {saving ? (
                                                        <>
                                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                            در حال ذخیره...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                            </svg>
                                                            {t('Update Post')}
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tabs.Tab>

                            <Tabs.Tab eventKey="2" title="متن">
                                <div className="p-6">
                                    <TissEditor component='prodcuts' parent={data.id} />
                                </div>
                            </Tabs.Tab>

                            <Tabs.Tab eventKey="3" title="سئو">
                                    <div className="p-6">
                                        {/* Language Selector */}
                                        <div className="mb-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                زبان / Language
                                            </label>
                                            <div className="flex gap-2 flex-wrap">
                                                {languages.map((lang) => (
                                                    <button
                                                        key={lang.code}
                                                        type="button"
                                                        onClick={() => setActiveLang(lang.code)}
                                                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                                            activeLang === lang.code
                                                                ? 'bg-blue-600 text-white'
                                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                        }`}
                                                    >
                                                        {lang.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-4" dir='rtl'>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">تیتر ({languages.find(l => l.code === activeLang)?.label})</label>
                                                <Input
                                                    value={data.title?.[activeLang] || ''}
                                                    className={inputstyle}
                                                    onChange={(e) => setData({ 
                                                        ...data, 
                                                        title: { 
                                                            ...data.title, 
                                                            [activeLang]: e 
                                                        } 
                                                    })}
                                                    placeholder="تیتر صفحه"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">{t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})</label>
                                                <Input
                                                    as={'textarea'}
                                                    rows={3}
                                                    value={data.keywords?.[activeLang] || ''}
                                                    className={inputstyle}
                                                    onChange={(e) => setData({ 
                                                        ...data, 
                                                        keywords: { 
                                                            ...data.keywords, 
                                                            [activeLang]: e 
                                                        } 
                                                    })}
                                                    placeholder="کلمات کلیدی (با کاما جدا کنید)"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">{t('Description')} ({languages.find(l => l.code === activeLang)?.label})</label>
                                                <Input
                                                    as={`textarea`}
                                                    rows={4}
                                                    value={data.description?.[activeLang] || ''}
                                                    className={inputstyle}
                                                    onChange={(e) => setData({ 
                                                        ...data, 
                                                        description: { 
                                                            ...data.description, 
                                                            [activeLang]: e 
                                                        } 
                                                    })}
                                                    placeholder="توضیحات متا"
                                                />
                                            </div>

                                            <Button
                                                type="button"
                                                onClick={save}
                                                disabled={saving}
                                                className='w-full sm:w-auto px-6'
                                                appearance="primary"
                                            >
                                                {saving ? 'در حال ذخیره...' : 'ذخیره سازی'}
                                            </Button>
                                        </div>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="4" title="قیمت گذاری">
                                    <div className="p-6">
                                        <div className="flex flex-col gap-4">
                                            <>
                                                <h3 className="text-lg font-semibold text-gray-800 mb-4">قیمت گذاری</h3>

                                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                                        <div>
                                                            <Button
                                                                className='w-full'
                                                                style={{
                                                                    backgroundColor: data.price == data.id ? '#dc2626' : '#4f46e5',
                                                                    color: '#fff'
                                                                }}
                                                                onClick={CreatePriceGroup}
                                                            >
                                                                قیمت گذاری انحصاری
                                                            </Button>
                                                        </div>
                                                        <div className='flex flex-col gap-2'>
                                                            <label className="text-sm font-medium text-gray-700">استفاده از قیمت گذاری گروهی</label>
                                                            <select
                                                                className={inputstyle}
                                                                value={data.price || ''}
                                                                onChange={(e) => {
                                                                    setData({ ...data, price: e.target.value });
                                                                    setKeyprice(keyprice + 1);
                                                                }}
                                                            >
                                                                <option value="">انتخاب کنید...</option>
                                                                {
                                                                    pricellist.map((item: any) => {
                                                                        return (
                                                                            <option key={item.id} value={item.id}>{getDisplayName(item.name)}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {data.price != null && data.price != "" && (
                                                        <div className="mt-4">
                                                            <PriceEditor Id={data.price} key={keyprice} />
                                                        </div>
                                                    )}
                                                </>
                                        </div>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="5" title="ویژگی ها">
                                    <div className="p-6">
                                        <div className='flex flex-col gap-6'>
                                            {/* Language Selector */}
                                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-200 p-4">
                                                <label className="block text-sm font-semibold text-gray-700 mb-3">
                                                    🌐 زبان / Language
                                                </label>
                                                <div className="flex gap-2 flex-wrap">
                                                    {languages.map((lang) => (
                                                        <button
                                                            key={lang.code}
                                                            type="button"
                                                            onClick={() => setActiveLang(lang.code)}
                                                            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                                                                activeLang === lang.code
                                                                    ? 'bg-blue-600 text-white shadow-md scale-105'
                                                                    : 'bg-white text-gray-700 hover:bg-blue-50 hover:shadow-sm border border-gray-200'
                                                            }`}
                                                        >
                                                            {lang.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Features Section */}
                                            <div>
                                                <div className="flex items-center justify-between mb-4">
                                                    <h3 className="text-lg font-bold text-gray-800">
                                                        ⚙️ ویژگی‌های محصول ({groupFeatures.length})
                                                    </h3>
                                                </div>
                                                
                                                {
                                                    groupFeatures.length > 0 ? (
                                                        <div className="space-y-4">
                                                            {groupFeatures.map((f: any) => {
                                                                const featureValue = productFeatureValues[f._id] || { ku: '', fa: '', en: '', ar: '', tr: '' };
                                                                const rawValue = getMultilingualValue(featureValue, activeLang);
                                                                const isCheckboxChecked = rawValue === '1' || rawValue === 'true';
                                                                const featureName = getDisplayName(f.name);
                                                                
                                                                const typeIcons: Record<string, string> = {
                                                                    'textbox': '📄',
                                                                    'number': '🔢',
                                                                    'checkbox': '☑️',
                                                                    'list': '📋'
                                                                };

                                                                return (
                                                                    <div 
                                                                        key={f._id} 
                                                                        className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-all duration-200"
                                                                    >
                                                                        <div className="flex flex-col gap-4">
                                                                            <div className="flex items-center gap-3">
                                                                                <span className="text-2xl">{typeIcons[f.type] || '📝'}</span>
                                                                                <div className="flex-1">
                                                                                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                                                                                        {featureName}
                                                                                    </label>
                                                                                    {f.options && Array.isArray(f.options) && f.options.length > 0 && f.type === 'list' && (
                                                                                        <p className="text-xs text-gray-500">
                                                                                            گزینه‌های موجود: {f.options.map((opt: any) => {
                                                                                                if (typeof opt === 'string') return opt;
                                                                                                return opt?.name && typeof opt.name === 'object' 
                                                                                                    ? getMultilingualValue(opt.name, activeLang) 
                                                                                                    : opt?.name || '';
                                                                                            }).join(', ')}
                                                                                        </p>
                                                                                    )}
                                                                                </div>
                                                                                {f.searchable && (
                                                                                    <span className="px-2 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-semibold">
                                                                                        🔍
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            
                                                                            <div className="bg-gray-50 rounded-lg p-3">
                                                                                {f.type === 'list' ? (
                                                                                    f.options && Array.isArray(f.options) && f.options.length > 0 ? (
                                                                                        <SelectPicker
                                                                                            className="w-full"
                                                                                            data={f.options.map((opt: any) => {
                                                                                                let optLabel = '';
                                                                                                let optValue = '';
                                                                                                
                                                                                                if (typeof opt === 'string') {
                                                                                                    optLabel = opt;
                                                                                                    optValue = opt;
                                                                                                } else if (opt && typeof opt === 'object') {
                                                                                                    // Get multilingual label
                                                                                                    if (opt.name && typeof opt.name === 'object') {
                                                                                                        optLabel = getMultilingualValue(opt.name, activeLang);
                                                                                                    } else if (typeof opt.name === 'string') {
                                                                                                        optLabel = opt.name;
                                                                                                    } else {
                                                                                                        optLabel = '';
                                                                                                    }
                                                                                                    
                                                                                                    // Use id as value, fallback to name
                                                                                                    optValue = opt.id || (typeof opt.name === 'string' ? opt.name : getMultilingualValue(opt.name, activeLang)) || '';
                                                                                                }
                                                                                                
                                                                                                return {
                                                                                                    label: optLabel || 'بدون نام',
                                                                                                    value: optValue
                                                                                                };
                                                                                            })}
                                                                                            value={rawValue || null}
                                                                                            onChange={(value) => handleChangeFeatureValue(f._id, value || '')}
                                                                                            placeholder={`انتخاب ${featureName}...`}
                                                                                            searchable={true}
                                                                                        />
                                                                                    ) : (
                                                                                        <TagInput
                                                                                            className="w-full"
                                                                                            value={rawValue ? String(rawValue).split(',').filter((x: string) => x !== '') : []}
                                                                                            onChange={(tags) => handleChangeFeatureValue(f._id, (tags || []).join(','))}
                                                                                            placeholder={`مقادیر ${featureName} را وارد کنید و اینتر بزنید`}
                                                                                        />
                                                                                    )
                                                                                ) : f.type === 'number' ? (
                                                                                    <Input
                                                                                        type="number"
                                                                                        className="w-full bg-white"
                                                                                        value={rawValue}
                                                                                        onChange={(val: any) => handleChangeFeatureValue(f._id, String(val ?? ''))}
                                                                                        placeholder={`عدد برای ${featureName}...`}
                                                                                    />
                                                                                ) : f.type === 'checkbox' ? (
                                                                                    <div className="flex items-center gap-3 bg-white rounded-lg p-3 border border-gray-200">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={isCheckboxChecked}
                                                                                            onChange={(e) => handleChangeFeatureValue(f._id, e.target.checked ? '1' : '0')}
                                                                                            className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
                                                                                        />
                                                                                        <span className="text-sm font-medium text-gray-700">
                                                                                            {isCheckboxChecked ? '✅ فعال' : '❌ غیرفعال'}
                                                                                        </span>
                                                                                    </div>
                                                                                ) : (
                                                                                    <Input
                                                                                        className="w-full bg-white"
                                                                                        value={rawValue}
                                                                                        onChange={(e: any) => handleChangeFeatureValue(f._id, e)}
                                                                                        placeholder={`مقدار ${featureName}...`}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    ) : (
                                                        <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-12 text-center">
                                                            <div className="text-4xl mb-3">📭</div>
                                                            <p className="text-gray-500 text-lg font-medium">هیچ ویژگی‌ای برای این گروه محصول تعریف نشده است</p>
                                                            <p className="text-gray-400 text-sm mt-1">لطفاً ابتدا در صفحه گروه محصول، ویژگی‌ها را تعریف کنید</p>
                                                        </div>
                                                    )
                                                }
                                            </div>

                                            {groupFeatures.length > 0 && (
                                                <div className="flex justify-end pt-4 border-t border-gray-200">
                                                    <Button
                                                        type="button"
                                                        onClick={saveProductFeatures}
                                                        className='px-8 py-2'
                                                        appearance="primary"
                                                        style={{ backgroundColor: '#2563eb' }}
                                                    >
                                                        💾 ذخیره ویژگی‌ها
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="6" title="سوالات متداول">
                                    <div className="p-6">
                                        <QACreator parent={data.id}></QACreator>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="7" title="تصاویر">
                                    <div className="p-6">
                                        <ImageUploaders count={1000} id={data.id} component={'OtherImage'}></ImageUploaders>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="8" title="نظرات">
                                    <div className="p-6">
                                        <div className="text-center text-gray-500 py-8">
                                            <p>بخش نظرات در حال توسعه است</p>
                                        </div>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="9" title="محصولات هدیه">
                                    <div className="p-6" dir="rtl">
                                        <div className="mb-4">
                                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                                مدیریت محصولات هدیه / Gift Products Management
                                            </h3>
                                            <p className="text-sm text-gray-600">
                                                می‌توانید چندین محصول هدیه را به این محصول اختصاص دهید
                                            </p>
                                        </div>
                                        <GiftProductSelector
                                            selectedGiftProducts={giftProducts}
                                            onSelectionChange={setGiftProducts}
                                            activeLang={activeLang}
                                        />
                                        <div className="mt-6 flex justify-end">
                                            <Button
                                                type="button"
                                                onClick={save}
                                                disabled={saving}
                                                appearance="primary"
                                                className="px-8 py-2"
                                            >
                                                {saving ? 'در حال ذخیره...' : 'ذخیره محصولات هدیه'}
                                            </Button>
                                        </div>
                                    </div>
                                </Tabs.Tab>

                                <Tabs.Tab eventKey="10" title="مقایسه قیمت">
                                    <div className="p-6" dir="rtl">
                                        <div className="mb-6">
                                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                                مقایسه قیمت با سایر بازارها / Price Comparison with Marketplaces
                                            </h3>
                                            <p className="text-sm text-gray-600">
                                                قیمت این محصول را در بازارهای مختلف مانند آمازون، علی‌بابا و سایر بازارها وارد کنید
                                            </p>
                                        </div>

                                        <div className="space-y-4">
                                            {(data?.marketplacePrices || []).map((item: any, index: number) => (
                                                <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                نام بازار / Marketplace
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={item.marketplace || ''}
                                                                onChange={(e) => {
                                                                    const updated = [...(data?.marketplacePrices || [])];
                                                                    updated[index] = { ...updated[index], marketplace: e.target.value };
                                                                    setData({ ...data, marketplacePrices: updated });
                                                                }}
                                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                placeholder="مثال: Amazon"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                قیمت / Price
                                                            </label>
                                                            <input
                                                                type="number"
                                                                value={item.price || ''}
                                                                onChange={(e) => {
                                                                    const updated = [...(data?.marketplacePrices || [])];
                                                                    updated[index] = { ...updated[index], price: parseFloat(e.target.value) || 0 };
                                                                    setData({ ...data, marketplacePrices: updated });
                                                                }}
                                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                placeholder="0.00"
                                                                dir="ltr"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                ارز / Currency
                                                            </label>
                                                            <select
                                                                value={item.currency || 'USD'}
                                                                onChange={(e) => {
                                                                    const updated = [...(data?.marketplacePrices || [])];
                                                                    updated[index] = { ...updated[index], currency: e.target.value };
                                                                    setData({ ...data, marketplacePrices: updated });
                                                                }}
                                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            >
                                                                <option value="USD">USD</option>
                                                                <option value="EUR">EUR</option>
                                                                <option value="GBP">GBP</option>
                                                                <option value="IRR">IRR (تومان)</option>
                                                                <option value="TRY">TRY</option>
                                                            </select>
                                                        </div>
                                                        <div className="flex items-end gap-2">
                                                            <div className="flex-1">
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                    لینک محصول / Product URL
                                                                </label>
                                                                <input
                                                                    type="url"
                                                                    value={item.url || ''}
                                                                    onChange={(e) => {
                                                                        const updated = [...(data?.marketplacePrices || [])];
                                                                        updated[index] = { ...updated[index], url: e.target.value };
                                                                        setData({ ...data, marketplacePrices: updated });
                                                                    }}
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                    placeholder="https://..."
                                                                    dir="ltr"
                                                                />
                                                            </div>
                                                            <Button
                                                                appearance="subtle"
                                                                color="red"
                                                                onClick={() => {
                                                                    const updated = [...(data?.marketplacePrices || [])];
                                                                    updated.splice(index, 1);
                                                                    setData({ ...data, marketplacePrices: updated });
                                                                }}
                                                                className="px-4"
                                                            >
                                                                حذف
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            <Button
                                                appearance="ghost"
                                                onClick={() => {
                                                    const updated = [...(data?.marketplacePrices || [])];
                                                    updated.push({
                                                        marketplace: '',
                                                        price: 0,
                                                        currency: 'USD',
                                                        url: ''
                                                    });
                                                    setData({ ...data, marketplacePrices: updated });
                                                }}
                                                className="w-full border-2 border-dashed border-gray-300 hover:border-blue-500"
                                            >
                                                + افزودن بازار جدید / Add New Marketplace
                                            </Button>
                                        </div>

                                        <div className="mt-6 flex justify-end">
                                            <Button
                                                type="button"
                                                onClick={save}
                                                disabled={saving}
                                                appearance="primary"
                                                className="px-8 py-2"
                                            >
                                                {saving ? 'در حال ذخیره...' : 'ذخیره مقایسه قیمت'}
                                            </Button>
                                        </div>
                                    </div>
                                </Tabs.Tab>
                        </Tabs>
                    </div>
                </div>
            )}
        </div>
    )
}
